import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// import { simpleFitCell } from './FitnessTrackerListe';
import { AgtSocialMediaVM } from 'app/stores/ui/agt.socialmedia.ui.store';
import { Icon } from 'app/components/common/Icon';
import { formatNum } from 'app/utils';

export const FansFollowerListe = observer(() => {
	const { berichteUiiStore, agtSocialMediaUiStore, agenturListUiStore, session } = useStore();
	const [hasItems, setHasItems] = useState(false);
	const tm = new TableModel<AgtSocialMediaVM, number>();
	const cols: ITableColumn<AgtSocialMediaVM, number>[] = [];

	const currentYear = agtSocialMediaUiStore.currentYear;

	cols.push({
		label: 'Agentur',
		path: 'agt.name',
		sortBy: 'agt.name',
		render: AgenturNameCell,
	});

	cols.push({
		label: 'FB Fans',
		path: `currFb.fans`,
		sortBy: `currFb.fans`,
		agg: [
			{
				path: `currFb.fans`,
				aggType: AggregrationType.count,
				aggIf: (val: any) => {
					return val >= 250;
				},
			},
			{
				path: `currFb.fans`,
				aggType: AggregrationType.avg,
				aggIf: (val: any) => {
					return val >= 0;
				},
			},
		],
	});

	cols.push({
		label: 'Fans VJ',
		path: `prevFb.fans`,
		sortBy: `prevFb.fans`,
		agg: [
			{
				path: `prevFb.fans`,
				aggType: AggregrationType.count,
				aggIf: (val: any) => {
					return val >= 250;
				},
			},
		],
	});

	cols.push({
		label: 'Insta Follower',
		path: `currInsta.follow`,
		sortBy: `currInsta.follow`,
		agg: [
			{
				path: `currInsta.follow`,
				aggType: AggregrationType.count,
				aggIf: (val: any) => {
					return val >= 250;
				},
			},
			{
				path: `currInsta.follow`,
				aggType: AggregrationType.avg,
				aggIf: (val: any) => {
					return val >= 0;
				},
			},
		],
	});

	cols.push({
		label: 'Follower VJ',
		path: `prevInsta.follow`,
		sortBy: `prevInsta.follow`,
		agg: [
			{
				path: `prevInsta.follow`,
				aggType: AggregrationType.count,
				aggIf: (val: any) => {
					return val >= 250;
				},
			},
		],
	});

	tm.sortBy = 'agt.name';
	tm.setCols(cols);

	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtSocialMediaUiStore.loadByMaxBmForYear(currentYear as number).then(() => {
			let items = agtSocialMediaUiStore.items;
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtSocialMediaVM[];
				items = agenturListUiStore.applyFilterOnGpRelevantAgt(items) as AgtSocialMediaVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtSocialMediaUiStore.items, agtSocialMediaUiStore]);

	return (
		<>
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
				</>
			)}
		</>
	);
});
